import { motion } from "framer-motion";
import { InquiryForm } from "./InquiryForm";
import { BlurIn } from "./ScrollAnimations";

export const InquirySection = () => {
  return (
    <section id="inquiry" data-testid="inquiry-section" className="py-24 sm:py-32 bg-white relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C8A23A]/20 to-transparent" aria-hidden="true" />
      <div className="container mx-auto px-6 sm:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 lg:gap-20 items-start">
          {/* Left — text */}
          <BlurIn className="lg:col-span-2">
            <span
              className="text-xs tracking-[0.2em] uppercase font-semibold text-[#C8A23A] mb-4 block"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Get a Quote
            </span>
            <h2
              className="text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#1A1A1A] mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
              data-testid="inquiry-heading"
            >
              Let's Plan Your <br /><span className="text-[#7A1A31]">Corporate Order</span>
            </h2>
            <p
              className="text-base text-[#6B7280] leading-relaxed mb-8"
              style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}
            >
              Fill in your requirements and our team will get back to you with the best pricing for your bulk order. Gold foiling, page insertions, or fully customised — we've got you covered.
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-[#7A1A31]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-[#7A1A31]" style={{ fontFamily: "'Outfit', sans-serif" }}>1</span>
                </div>
                <p className="text-sm text-[#6B7280]" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}>
                  <strong className="text-[#1A1A1A] font-medium">Submit your requirement</strong> — quantity, category, and customisation needs.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-[#7A1A31]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-[#7A1A31]" style={{ fontFamily: "'Outfit', sans-serif" }}>2</span>
                </div>
                <p className="text-sm text-[#6B7280]" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}>
                  <strong className="text-[#1A1A1A] font-medium">Get a personalised quote</strong> — our team will call or WhatsApp you within 24 hours.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-[#7A1A31]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-[#7A1A31]" style={{ fontFamily: "'Outfit', sans-serif" }}>3</span>
                </div>
                <p className="text-sm text-[#6B7280]" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}>
                  <strong className="text-[#1A1A1A] font-medium">Approve & receive</strong> — we handle customisation, production, and delivery.
                </p>
              </div>
            </div>
          </BlurIn>

          {/* Right — form */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="lg:col-span-3 bg-[#FAFAF7] border border-black/5 rounded-2xl p-8 sm:p-10"
          >
            <InquiryForm source="home" variant="light" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
